"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var WindowPerformanceRowsDataDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowPerformanceRowsDataDTOConverter, _DataObjectConverter_);

  function WindowPerformanceRowsDataDTOConverter() {
    _classCallCheck(this, WindowPerformanceRowsDataDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowPerformanceRowsDataDTOConverter).apply(this, arguments));
  }

  return WindowPerformanceRowsDataDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowPerformanceRowsDataDTOConverter = WindowPerformanceRowsDataDTOConverter;